import React from "react";
import { GenericChartResponseDTO } from "submodules/nerit-aquatec-sdk/services/charts/dtos/responses/GenericChartResponseDTO";
import { HighChartsUtils } from "modules/reports/components/charts/card-chart/inner/HighChartsUtils";
import { CardHighChartCP } from "modules/reports/components/charts/card-chart/CardHighChartCP";
import { DateUtils } from "submodules/nerit-framework-utils/utils/date/DateUtils";
import { DateFormatEnum } from "submodules/nerit-framework-utils/utils/enums/DateFormatEnum";

interface ICPProps {
  data: GenericChartResponseDTO;
  filters: {
    regulationName?: string;
    fieldName: string;
    locationCodes: number[];
  };
}

/**
 */
export function ChartGeographicCP(props: ICPProps): JSX.Element {
  const categories: string[] = [];
  const chartFormattedData: {x: number, y: number, custom: {date?: string}}[] = [];

  // Tem que estar ordenado pela ordem selecionada no filtro
  let index = 0;

  props.filters.locationCodes.forEach((code) => {
    const serie = props.data.series.find((item) => code === item.code);
    if (!serie) return;

    categories.push(serie.xAxisLabel);

    serie.dataArray.forEach((item) => {
      chartFormattedData.push({
        x: index,
        y: +item.y,
        custom: { date: item?.date ?? undefined }
      });
    });

    index += 1;
  });

  const series: any = [
    {
      name: props.filters.fieldName,
      data: chartFormattedData,
    },
  ];

  if (!!props.data.regulationLimit?.minPermitted) {

    const minPermittedSerie = HighChartsUtils.getMinOrMaxPermittedSerie(
      "min",
      props.data.series.length,
      props.data.regulationLimit?.minPermitted,
      props.filters.regulationName
    );

    const minWithCustomProp = {
      ...minPermittedSerie,
      custom: {isLimitValue: true}
    };

    series.push(minWithCustomProp)
  }

  if (!!props.data.regulationLimit?.maxPermitted) {
    const maxPermittedSerie = HighChartsUtils.getMinOrMaxPermittedSerie(
      "max",
      props.data.series.length,
      props.data.regulationLimit?.maxPermitted,
      props.filters.regulationName
    );

    const maxWithCustomProp = {
      ...maxPermittedSerie,
      custom: {isLimitValue: true}
    };

    series.push(maxWithCustomProp)
  }

  return (
    <CardHighChartCP
      chartType={"scatter"}
      buttonsToHide={["chartType"]}
      chartOptions={{
        chart: HighChartsUtils.getChart("scatter"),
        title: HighChartsUtils.getTitle(
          `Gráfico geográfico ${
            !!props.filters.fieldName && `do ${props.filters.fieldName}`
          }`
        ),
        series: series,
        xAxis: {
          categories: categories,
        },
        yAxis: {
          title: {
            text: props.filters.fieldName,
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function formatToolTip() : string {

            if (this.series.userOptions.custom?.isLimitValue) {
              return '<b>'+ this.series.name + '</b><br/>'+
                    'Valor: ' + this.y + '<br/>'
            }
            
            if (this.point.options.custom?.date) {
              return '<b>'+ this.series.name + '</b><br/>'+
                    'Valor: ' + this.y + '<br/>' +
                    'Data: ' + DateUtils.formatDate(this.point.options.custom?.date, DateFormatEnum.BR_WITHOUT_TIME)
            }

            return `
              <b>${this.series.name}</b><br/>
              Valor: ${this.y}
            `
          }
        },
        exporting: {
          enabled: true,
        },
      }}
    />
  );
}
